import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({namespaced: true, stateFactory: true})
export default class ListModule extends VuexModule {
  loading = false;
  items = {};
  filteredItems = {};

  get getItems() {
    return this.items;
  }

  get getTypeName2s() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const names = this.items
      .map(type => type.TYPName2)
      .sort()
      .filter(type => type !== null);

    for (const each of names) {
      items[each] = each;
    }

    return items
  }

  get getPhs() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const names = this.items
      .map(type => type.ph)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .filter(type => type !== null);

    for (const each of names) {
      items[each] = each;
    }

    return items
  }

  get getFuelTypes() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const fuelTypes = this.items.map(item => item.fuelType);

    for (const each of fuelTypes) {
      items[each] = each;
    }

    return items
  }

  get getTransTypes() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const transTypes = this.items.map(item => item.transType);

    for (const each of transTypes) {
      items[each] = each;
    }

    return items
  }

  get getTCOCo2EmiV2s() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const TCOCo2EmiV2 = this.items
      .filter(item => item.consumer.TCOCo2EmiV2 !== null)
      .map(item => item.consumer.TCOCo2EmiV2)
      .sort((a, b) => parseInt(a) - parseInt(b));

    for (const each of TCOCo2EmiV2) {
      items[each] = each + " g / km";
    }

    return items
  }


  get getSeats() {
    const items = {'': ''};

    if (!this.items.map) {
      return items;
    }

    const seats = this.items
      .filter(item => item.TYPSeat !== null)
      .map(item => item.TYPSeat)
      .sort((a, b) => parseInt(a) - parseInt(b));

    for (const each of seats) {
      items[each] = each;
    }

    return items
  }

  get getFilteredItems() {
    return this.filteredItems;
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading;
  }

  @Mutation
  setItems(items) {
    this.items = items;
  }

  @Mutation
  setFilteredItems(items) {
    this.filteredItems = items;
  }

  @Action
  fetchAll(items) {
    const commit = this.context.commit;

    this.context.commit('setItems', items);
    this.context.commit('setFilteredItems', items);
  }

  @Action
  applyFilter(filters) {
    const commit = this.context.commit;

    const items = this.context.state.items.filter(item => {
      let filtered = true;

      if (filters.typename2) {
        filtered = filtered && item.TYPName2 === filters.typename2
      }

      if (filters.ph) {
        filtered = filtered && item.ph === filters.ph
      }

      if (filters.fuelType) {
        filtered = filtered && item.fuelType === filters.fuelType
      }

      if (filters.transType) {
        filtered = filtered && item.transType === filters.transType
      }

      if (filters.seats) {
        filtered = filtered && parseInt(item.TYPSeat) === parseInt(filters.seats)
      }

      if (filters.TCOCo2EmiV2) {
        filtered = filtered && item.consumer.TCOCo2EmiV2 === parseInt(filters.TCOCo2EmiV2)
      }

      return filtered;
    });
    commit('setFilteredItems', items);
  }
}
